const Configuration = {
	version: "DEV",
	basePath: "",
	publicUrl: "https://imera.esch.design",
	apiUrl: "https://imera.esch.design/web/application/index.php/v1",
	vatRegex: new RegExp( "^(ATU[0-9]{8}|BE[01][0-9]{9}|BG[0-9]{9,10}|HR[0-9]{11}|CY[A-Z0-9]{9}|CZ[0-9]{8,10}|DK[0-9]{8}|EE[0-9]{9}|FI[0-9]{8}|FR[0-9A-Z]{2}[0-9]{9}|DE[0-9]{9}|EL[0-9]{9}|HU[0-9]{8}|IE([0-9]{7}[A-Z]{1,2}|[0-9][A-Z][0-9]{5}[A-Z])|IT[0-9]{11}|LV[0-9]{11}|LT([0-9]{9}|[0-9]{12})|LU[0-9]{8}|MT[0-9]{8}|NL[0-9]{9}B[0-9]{2}|PL[0-9]{10}|PT[0-9]{9}|RO[0-9]{2,10}|SK[0-9]{10}|SI[0-9]{8}|ES[A-Z]([0-9]{8}|[0-9]{7}[A-Z])|SE[0-9]{12}|GB([0-9]{9}|[0-9]{12}|GD[0-4][0-9]{2}|HA[5-9][0-9]{2}))$" ),
	passwordRegex: new RegExp( "(?=.*[!@#$%^&\"'.,+*-])(?=.{8,})" ),
	currencyRegex: new RegExp( "^(\\d{1,})(,\\d{1,4})*(\\.\\d{1,4})?$" ),
	domainRegex: new RegExp( /^((?:(?:(?:\w[.\-+]?)*)\w)+)((?:(?:(?:\w[.\-+]?){0,62})\w)+)\.(\w{2,6})$/ ),
	validMimeTypes: [
		"image/jpeg",
		"image/png",
		"image/gif",
		"application/pdf",
		"application/msword",
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		"application/msexcel",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		"application/mspowerpoint",
		"application/vnd.openxmlformats-officedocument.presentationml.presentation",
		"text/plain"
	],
	maximumFileSize: 10000000,
	location: "de-DE",
	// pluginName: "questionnaires",
	pluginName: "reports",
	priceString: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
	dateString: { day: "numeric", month: "numeric", year: "numeric", hour: "numeric", minute: "numeric" }
};

// Übersetzungen
export const translations = {
	imera_types: {
		questionnaire: "Imera",
		questionnaires: "Imera",
		survey: "Recherche",
		surveys: "Recherchen",
		question: "Frage",
		questions: "Fragen"
	},
	de_DE: {
		words: {
			appName: "Imera",
			questionnaire: "Imera",
			questionnaires: "Imera",
			questionnairesOverview: "Imera",
			questionnaireCofigurator: "Imera Konfigurator",
			questionnaireBlock: "Block",
			survey: "Recherche",
			surveys: "Recherchen",
			surveysOverview: "Recherchenübersicht",
			question: "Frage",
			questions: "Fragen",
			toRegistrate: "Registrieren",
			registration: "Registrierung",
			data_protection: "Datenschutzerklärung",
			domain: "Domain"
		},
		routes: {
			survey: "/recherche",
			surveys: "/recherchenuebersicht",
			surveyTest: "/recherchen-test",
			questionnaire: "/safety-app",
			questionnaires: "/safety-apps",
			registration: "/registrieren",
			agb_approval: "/agb",
			data_protection_approval: "/datenschutz"
		}
	}
};

export default Configuration;